import React, { useState, useEffect } from 'react';
import './Explore5.css';
import Explore6 from './Explore6';
import BookExpert from './BookExpert';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Login from '../Login/Login';
import { therapistService } from '../../services';

const Explore5 = () => {
  const [selectedTherapist, setSelectedTherapist] = useState(null);
  const [showExplore6, setShowExplore6] = useState(false);
  const [showBookExpert, setShowBookExpert] = useState(false);
  const [showLogin, setShowLogin] = useState(false);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [therapistsFromApi, setTherapistsFromApi] = useState(null);
  const [showRaw, setShowRaw] = useState(false);

  const handleTherapistSelect = (therapist) => {
    setSelectedTherapist(therapist);
    console.log('Selected therapist:', therapist);
  };

  const handleMaybeLater = () => {
    console.log('User chose Maybe Later');
    setShowExplore6(true);
  };

  const handleTakeLesson = () => {
    setShowBookExpert(true);
  };


  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const res = await therapistService.getAll();
        // Normalize response to a consistent UI shape
        const rawArray = Array.isArray(res) ? res : res?.data || [];
        const normalized = (rawArray || []).map(normalizeTherapist).filter(Boolean);
        setTherapistsFromApi(normalized);
      } catch (err) {
        console.error('Failed to load therapists', err);
        setError('Failed to load therapists');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  // Normalize various backend shapes to a single UI-friendly object
  function normalizeTherapist(raw) {
    if (!raw) return null;
    const id = raw.id || raw._id || raw.therapistId || raw.userId || raw.id_user || null;
    const name = raw.display_name || raw.name || raw.displayName || raw.fullName || raw.userName || raw.username || '';
    const specialization = Array.isArray(raw.specialization)
      ? raw.specialization
      : (typeof raw.specialization === 'string' && raw.specialization.length ? raw.specialization.split(',').map(s => s.trim()) :
        Array.isArray(raw.specialities) ? raw.specialities :
        (raw.specialty ? [raw.specialty] : []));
    const years = raw.years_of_experience ?? raw.YearsOfExperience ?? raw.yearsExperience ?? raw.experienceYears ?? raw.experience ?? raw.years ?? null;
    // Price: try numeric VND or formatted string
    const rawPrice = raw.hourly_rate || raw.hourlyRate || raw.price || raw.fee || raw.rate || raw.hourly_price || '';
    let priceValue = '';
    if (rawPrice !== null && rawPrice !== undefined && rawPrice !== '') {
      const s = String(rawPrice).trim();
      if (/^\d+$/.test(s)) {
        priceValue = Number(s);
      } else if (/^[\d,.]+$/.test(s)) {
        // numeric with decimals/commas
        priceValue = Number(s.replace(/,/g, '')) || s;
      } else {
        priceValue = s; // leave as-is (e.g., 'Free' or 'Contact')
      }
    }

  const rating = raw.rating || raw.averageRating || raw.avgRating || raw.reviewScore || null;
    const isAccepting = raw.is_accepting_clients ?? raw.isAcceptingClients ?? raw.isAccepting ?? raw.available ?? false;
    const verified = raw.is_verified ?? raw.verified ?? false;
  const description = raw.description || raw.bio || raw.profileSummary || raw.summary || '';
  const qualifications = Array.isArray(raw.qualifications) ? raw.qualifications : (Array.isArray(raw.Qualifications) ? raw.Qualifications : (raw.qualifications && typeof raw.qualifications === 'string' ? raw.qualifications.split(',').map(s => s.trim()) : []));

    return {
      id,
      name,
      specialization,
      years,
      years_of_experience: years,
      priceValue,
      rating,
      is_accepting_clients: Boolean(isAccepting),
      is_verified: Boolean(verified),
      description,
      qualifications,
      raw
    };
  }

  // If user chose Maybe Later, show Explore6
  if (showExplore6) {
    return <Explore6 />;
  }

  // If user clicked Take Lesson, show BookExpert
  if (showBookExpert) {
    return <BookExpert />;
  }

  // If user clicked Login, show Login page
  if (showLogin) {
    return <Login />;
  }

  // We no longer use hard-coded therapists. The UI renders therapists from the API only.

  return (
    <div className="explore5-container page-with-header">
      <Header 
        showBookExpert={showBookExpert} 
        setShowBookExpert={setShowBookExpert}
        showLogin={showLogin}
        setShowLogin={setShowLogin}
      />

      {/* Main Content */}
      <div className="main-content">
        <div className="content-wrapper">
          <h1 className="main-title">Help us get to know you</h1>
          <p className="subtitle">Please answer the following questions.</p>
          
          <div className="therapists-section">
            <div style={{ textAlign: 'right', marginBottom: 8 }}>
              <button className="maybe-later-btn" onClick={() => setShowRaw(s => !s)} style={{ padding: '6px 10px', fontSize: 12 }}>
                {showRaw ? 'Hide raw response' : 'Show raw response'}
              </button>
            </div>
            {loading ? (
              <div>Loading therapists...</div>
            ) : error ? (
              <div className="error">{error}</div>
            ) : (
              <>
                {Array.isArray(therapistsFromApi) && therapistsFromApi.length === 0 ? (
                  <div className="no-therapists">No therapists found. Please ensure you are logged in and the backend has data.</div>
                ) : (
                  <div className="therapists-grid">
                    {(therapistsFromApi || []).map((therapist) => {
                      const id = therapist.id || therapist._id || therapist.therapistId || therapist.idx || therapist.raw?.id;
                      const name = therapist.name || therapist.display_name || therapist.raw?.display_name || therapist.raw?.displayName || 'Chuyên gia';
                      const specialtyArray = Array.isArray(therapist.specialization) ? therapist.specialization : (therapist.raw?.specialization || []);
                      const specialty = Array.isArray(specialtyArray) ? specialtyArray.join(', ') : (specialtyArray || 'Chuyên gia tâm lý');
                      const years = (therapist.years_of_experience ?? therapist.years ?? therapist.raw?.years_of_experience) || null;
                      const priceValue = therapist.priceValue || therapist.raw?.hourly_rate || therapist.raw?.HourlyRate || null;
                      let price = '';
                      if (priceValue !== null && priceValue !== undefined && priceValue !== '') {
                        if (typeof priceValue === 'number') {
                          price = Number(priceValue).toLocaleString('vi-VN') + 'đ';
                        } else if (/^\d+$/.test(String(priceValue))) {
                          price = Number(String(priceValue)).toLocaleString('vi-VN') + 'đ';
                        } else {
                          price = String(priceValue);
                        }
                      }
                      const rating = therapist.rating || therapist.averageRating || therapist.raw?.rating || '';
                      const availabilityText = therapist.is_accepting_clients ? 'Có lịch tuần này' : 'Không có lịch';
                      const verified = therapist.is_verified || therapist.verified || therapist.raw?.is_verified || false;
                      const qualifications = Array.isArray(therapist.qualifications) ? therapist.qualifications : (therapist.raw?.qualifications || []);

                      return (
                        <div key={id || name} className="therapist-card">
                          <div className="therapist-tag">{specialty}</div>
                          <div className="therapist-content">
                            <h3 className="therapist-name">{name} {verified ? <span className="verified">✔</span> : null}</h3>
                            {years ? <p className="therapist-experience">{years} năm kinh nghiệm</p> : null}
                            {rating ? <p className="therapist-rating">★ {rating}</p> : null}
                            <p className="therapist-description">{therapist.description || (Array.isArray(qualifications) ? qualifications.join(' · ') : qualifications)}</p>
                            {price ? <p className="therapist-price">{price} /buổi</p> : null}
                            <div className={`therapist-availability ${therapist.is_accepting_clients ? 'available' : 'unavailable'}`}>{availabilityText}</div>
                          </div>
                          <button 
                            className="take-lesson-btn"
                            onClick={() => { handleTherapistSelect(therapist); handleTakeLesson(); }}
                          >
                            Đặt lịch
                          </button>
                        </div>
                      );
                    })}
                  </div>
                )}
                  {showRaw && (
                    <pre style={{ textAlign: 'left', whiteSpace: 'pre-wrap', wordBreak: 'break-word', marginTop: 16, background: '#f6f8fa', padding: 12, borderRadius: 6 }}>
                      {JSON.stringify(therapistsFromApi, null, 2)}
                    </pre>
                  )}
              </>
            )}

            <button className="maybe-later-btn" onClick={handleMaybeLater}>
              Maybe Later
            </button>
          </div>
        </div>
      </div>

      {/* Floating Chat Icon */}
      <div className="chat-icon">
        <div className="monitor">
          <div className="screen">
            <div className="face">
              <div className="eyes">
                <span className="eye">"</span>
                <span className="eye">"</span>
              </div>
              <div className="mouth">)</div>
            </div>
          </div>
          <div className="base"></div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default Explore5;

